module.exports = __webpack_public_path__ + "media/images/happy-4a4bcbb1a8a4b1d8f07070ef211e2e33.svg";